import PropTypes from "prop-types";
import { ColumnDefaultProps, ColumnPropTypes } from "../../../props";

function Content({ column, text, item, i }) {
  let element = text;

  if (column.render && typeof column.render === "function") {
    element = column.render({ text, item, i, field: text });
  }

  return element;
}

Content.defaultProps = {
  text: null,
  column: ColumnDefaultProps
};

Content.propTypes = {
  text: PropTypes.any,
  i: PropTypes.number.isRequired,
  column: ColumnPropTypes
};

export default Content;
